import { render } from "./CyberIcons.vue?vue&type=template&id=3578a11a&scoped=true"
const script = {}

import "./CyberIcons.vue?vue&type=style&index=0&id=3578a11a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3578a11a"]])

export default __exports__